export const ACCREDITATION_REJECTION_REASON_CODES = [
  'document_not_valid_anymore',
  'document_unreadable',
  'document_not_complete',
  'incorrect_certificate_type',
] as const;

export type AccreditationRejectionReasonCode =
  (typeof ACCREDITATION_REJECTION_REASON_CODES)[number];
